import { useEffect } from "react";
import "./GDPRPage.scss";

function GDPRPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <main className="gdpr-page">
      <div className="gdpr-page__container">
        <h1 className="gdpr-page__title">Zásady ochrany osobných údajov (GDPR)</h1>
        <p className="gdpr-page__meta">platné od: 3. 10. 2026</p>

        <section className="gdpr-page__section">
          <h2 className="gdpr-page__heading">Kto spracúva osobné údaje</h2>
          <p>
            Záleží na tom, o ktoré údaje ide — a nie je to formalita, lebo od toho
            závisí, komu píšete, keď si chcete uplatniť svoje práva.
          </p>
          <ul className="gdpr-page__list">
            <li>
              <strong>Pri objednávke jedla a zákazníckom účte</strong> je prevádzkovateľom
              <strong> prevádzka</strong>, u ktorej si objednávate. Jej identifikačné údaje
              nájdete v <a href="vop">Obchodných podmienkach</a> a v sekcii Kontakt.
              Spoločnosť INVER je pri nich iba <strong>sprostredkovateľom</strong> — dodáva
              softvér, spracúva údaje na pokyn prevádzky a nepoužíva ich na vlastné účely.
            </li>
            <li>
              <strong>Pri návšteve stránky, kontaktnom formulári a hláseniach chýb</strong> je
              prevádzkovateľom spoločnosť <strong>INVER spol. s r.o.</strong>, so sídlom
              Hutnícka 1, 040 01 Košice, IČO: 31665462, e-mail: admin@rozvozy.sk.
            </li>
          </ul>
          <p>
            Ak si nie ste istí, komu sa obrátiť, napíšte na admin@rozvozy.sk — žiadosť
            posunieme príslušnej prevádzke.
          </p>
        </section>

        <section className="gdpr-page__section">
          <h2 className="gdpr-page__heading">Aké údaje spracúvame a prečo</h2>
          <p>
            Prezerať si denné menu môžete bez registrácie. Účet potrebujete, až keď si
            chcete objednať cez web. Osobné údaje preto spracúvame v týchto štyroch
            prípadoch:
          </p>

          <div className="gdpr-page__subsection">
            <h3 className="gdpr-page__subheading">A. Bežní návštevníci webu</h3>
            <ul className="gdpr-page__list">
              <li>
                <strong>Aké údaje:</strong> IP adresa, základné technické logy a nevyhnutné
                technické cookies (slúžiace len na správne zobrazenie a bezpečnosť webu).
              </li>
              <li>
                <strong>Prečo (Účel):</strong> Zabezpečenie technického chodu a bezpečnosti
                platformy.
              </li>
              <li>
                <strong>Právny základ:</strong> Oprávnený záujem Prevádzkovateľa (čl. 6 ods. 1
                písm. f) GDPR).
              </li>
            </ul>
          </div>

          <div className="gdpr-page__subsection">
            <h3 className="gdpr-page__subheading">B. Zástupcovia a manažéri partnerských prevádzok</h3>
            <ul className="gdpr-page__list">
              <li>
                <strong>Aké údaje:</strong> Meno, priezvisko, e-mailová adresa a telefónne číslo.
                Tieto údaje nezadávate na webe vy, ale vytvára ich pre vás administrátor platformy
                pri uzatváraní spolupráce.
              </li>
              <li>
                <strong>Prečo (Účel):</strong> Vytvorenie prístupu do administrátorského rozhrania
                prevádzky, komunikácia k zmluve a technická podpora.
              </li>
              <li>
                <strong>Právny základ:</strong> Plnenie zmluvy o spolupráci (čl. 6 ods. 1 písm. b)
                GDPR).
              </li>
            </ul>
          </div>

          <div className="gdpr-page__subsection">
            <h3 className="gdpr-page__subheading">C. Zákazníci, ktorých údaje zadala do systému prevádzka (Telefonické objednávky)</h3>
            <ul className="gdpr-page__list">
              <li>
                <strong>Aké údaje:</strong> Ak si telefonicky objednáte tovar u niektorej z
                partnerských prevádzok, prevádzka môže pre účely vybavenia a doručenia vašej
                objednávky zadať do nášho systému vaše údaje (meno, adresa doručenia, telefónne
                číslo a obsah objednávky).
              </li>
              <li>
                <strong>Naša rola (Sprostredkovateľ):</strong> K týmto údajom pristupujeme výlučne
                ako poskytovateľ softvérového riešenia (tzv. sprostredkovateľ v zmysle GDPR) pre
                danú prevádzku. Údaje nezhromažďujeme pre naše vlastné účely a nepoužívame ich na
                žiadny vlastný marketing.
              </li>
              <li>
                <strong>Zodpovednosť prevádzky:</strong> Právny základ na spracovanie týchto údajov
                (plnenie zmluvy o dodaní jedla) a zodpovednosť za ne nesie v plnom rozsahu konkrétna
                prevádzka, u ktorej ste si jedlo objednali.
              </li>
            </ul>
          </div>

          <div className="gdpr-page__subsection">
            <h3 className="gdpr-page__subheading">D. Zákazníci s webovým účtom (objednávky cez web)</h3>
            <ul className="gdpr-page__list">
              <li>
                <strong>Aké údaje:</strong> meno a priezvisko, e-mail, telefónne číslo, doručovacie
                adresy vrátane polohy na mape a spresnenia pre vodiča, obsah a história objednávok,
                stav vášho konta (nedoplatok alebo preplatok) a dátum odsúhlasenia obchodných
                podmienok.
              </li>
              <li>
                <strong>Prečo (Účel):</strong> prijatie a vybavenie objednávky, doručenie jedla,
                vyúčtovanie a komunikácia o objednávke (potvrdenie, zmena, zrušenie).
                Poloha adresy slúži vodičovi na to, aby vás našiel.
              </li>
              <li>
                <strong>Právny základ:</strong> plnenie zmluvy (čl. 6 ods. 1 písm. b) GDPR).
                Pri daňových dokladoch zákonná povinnosť (čl. 6 ods. 1 písm. c) GDPR).
              </li>
              <li>
                <strong>Kto je prevádzkovateľ:</strong> prevádzka, u ktorej si objednávate.
                INVER je sprostredkovateľ — údaje spracúva na jej pokyn, nepoužíva ich na
                vlastný marketing a neposkytuje ich ďalej.
              </li>
              <li>
                <strong>Čo nespracúvame:</strong> cez stránku sa neplatí, takže neuchovávame
                žiadne platobné údaje ani čísla kariet.
              </li>
            </ul>
          </div>
        </section>

        <section className="gdpr-page__section">
          <h2 className="gdpr-page__heading">Komu údaje poskytujeme</h2>
          <p>
            Vaše osobné údaje nezdieľame so žiadnymi tretími stranami na marketingové účely
            a nepredávame ich.
          </p>
          <ul className="gdpr-page__list">
            <li>
              <strong>Prevádzka a jej zamestnanci:</strong> obsluha vidí vašu objednávku,
              kontakt a adresu. Vodič, ktorý vám jedlo vezie, vidí meno, adresu, telefónne
              číslo, obsah objednávky a sumu na úhradu — bez toho by vám ju nedoručil.
            </li>
            <li>
              <strong>INVER ako sprostredkovateľ:</strong> prístup k údajom má len v rozsahu
              potrebnom na chod a podporu systému.
            </li>
            <li>
              <strong>Dodávatelia:</strong> poskytovateľ webhostingu, IT správy a e-mailovej
              služby. Sú viazaní mlčanlivosťou a spracúvajú údaje len na náš pokyn.
            </li>
            <li>
              <strong>Orgány verejnej moci:</strong> ak nám to ukladá zákon.
            </li>
          </ul>

          <h3 className="gdpr-page__subheading">Služby tretích strán na stránke</h3>
          {/*
            POZOR: tu sa zámerne netvrdí, aký prenosový mechanizmus je uzatvorený.
            To závisí od zmlúv s poskytovateľmi a patrí to do právnej kontroly —
            nie je to vec, ktorú by mal vypísať vývojár.
          */}
          <p>
            Stránka využíva nasledujúce externé služby. Ich poskytovatelia môžu údaje
            spracúvať aj na serveroch mimo Európskeho hospodárskeho priestoru; dochádza
            k tomu na základe zmluvných podmienok uzatvorených s nimi.
          </p>
          <ul className="gdpr-page__list">
            <li>
              <strong>Google Analytics 4</strong> (Google Ireland Ltd.) — anonymná štatistika
              návštevnosti. Spúšťa sa <strong>až po vašom súhlase</strong> v okne o cookies
              a súhlas môžete kedykoľvek odvolať. Právny základ: súhlas
              (čl. 6 ods. 1 písm. a) GDPR).
            </li>
            <li>
              <strong>Google Maps / Places</strong> (Google Ireland Ltd.) — vyhľadanie a potvrdenie
              adresy na mape pri registrácii a v profile. Spracuje sa to, čo do poľa napíšete,
              a poloha, ktorú potvrdíte. Právny základ: plnenie zmluvy.
            </li>
            <li>
              <strong>Cloudflare Turnstile</strong> (Cloudflare, Inc.) — overenie, že formulár
              nevypĺňa robot (registrácia, kontakt, obnova hesla). Právny základ: oprávnený
              záujem na ochrane pred zneužitím formulárov.
            </li>
            <li>
              <strong>Poskytovateľ webhostingu a e-mailovej služby</strong> — prevádzka serverov
              a odosielanie e-mailov o objednávke.
            </li>
          </ul>
          <p>
            <strong>Písmo stránky sa z internetu nenačítava</strong> — je súčasťou aplikácie
            a ide z nášho servera. Pri jeho zobrazení sa teda nikam neposiela vaša IP adresa.
          </p>

          <h3 className="gdpr-page__subheading">Hlásenie chýb</h3>
          <p>
            Tlačidlom „Nahlásiť chybu“ nám viete poslať popis problému spolu so
            <strong> snímkou obrazovky</strong> a technickými údajmi o prehliadači. Snímka môže
            zachytiť aj údaje, ktoré máte práve na obrazovke. <strong>Snímka sa neukladá
            do databázy</strong> — posiela sa iba e-mailom na adresu podpory a v systéme
            zostáva len poznámka, že k hláseniu bola priložená. Právny základ: oprávnený
            záujem na odstraňovaní chýb.
          </p>
        </section>

        <section className="gdpr-page__section">
          <h2 className="gdpr-page__heading">Cookies a údaje uložené vo vašom prehliadači</h2>
          <p>
            Väčšina toho, čo si stránka ukladá, nie sú klasické cookies, ale úložisko
            prehliadača (<em>localStorage</em> a <em>sessionStorage</em>). Na posúdenie
            je to jedno — ide o údaje uložené vo vašom zariadení, preto ich uvádzame
            rovnako.
          </p>

          <h3 className="gdpr-page__subheading">Nevyhnutné — bez nich stránka nefunguje</h3>
          <table className="gdpr-page__table">
            <thead>
              <tr><th>Názov</th><th>Načo je</th><th>Ako dlho</th></tr>
            </thead>
            <tbody>
              <tr>
                <td><code>authToken@…</code></td>
                <td>Udrží vás prihláseného. Pre každú prevádzku zvlášť.</td>
                <td>Do zatvorenia prehliadača; pri voľbe „zapamätať si ma“ do odhlásenia.</td>
              </tr>
              <tr>
                <td><code>cookie_consent</code></td>
                <td>Vaša voľba v tomto okne — aby sme sa nepýtali znova.</td>
                <td>Do zmazania údajov prehliadača.</td>
              </tr>
              <tr>
                <td><code>rozvozy-rt-leader@…</code></td>
                <td>
                  Určuje, ktorá otvorená záložka drží spojenie so serverom, aby ich
                  nebolo otvorených zbytočne veľa.
                </td>
                <td>Krátkodobé, priebežne sa prepisuje.</td>
              </tr>
              <tr>
                <td><code>vzhlad</code></td>
                <td>
                  Svetlý, tmavý alebo automatický režim, ak ste si ho vybrali
                  sami. Bez voľby je stránka svetlá a neukladá sa nič.
                </td>
                <td>Do zmazania údajov prehliadača.</td>
              </tr>
              <tr>
                <td><code>webObjednavkyZvuk</code></td>
                <td>
                  Zapnutý zvuk upozornenia na novú objednávku. Len pre obsluhu
                  prevádzky.
                </td>
                <td>Do zmazania údajov prehliadača.</td>
              </tr>
            </tbody>
          </table>

          <h3 className="gdpr-page__subheading">Analytické — len s vaším súhlasom</h3>
          <table className="gdpr-page__table">
            <thead>
              <tr><th>Názov</th><th>Načo je</th><th>Ako dlho</th></tr>
            </thead>
            <tbody>
              <tr>
                <td><code>_ga</code>, <code>_ga_…</code></td>
                <td>Google Analytics — rozlíšenie návštevníkov v štatistike návštevnosti.</td>
                <td>Spravidla 2 roky.</td>
              </tr>
              <tr>
                <td><code>_gid</code>, <code>_gat</code></td>
                <td>Google Analytics — rozlíšenie návštev a obmedzenie počtu požiadaviek.</td>
                <td>24 hodín, resp. 1 minúta.</td>
              </tr>
            </tbody>
          </table>
          <p>
            Tieto sa nastavia <strong>až po tom, čo analytiku povolíte</strong>. Keď súhlas
            odvoláte, Google Analytics sa zastaví a tieto cookies odstránime.
          </p>
          <p>
            <strong>Marketingové ani reklamné cookies nepoužívame.</strong> Cloudflare
            Turnstile (overenie, že formulár nevypĺňa robot) môže pri overovaní uložiť
            vlastný technický údaj; slúži výlučne na toto overenie.
          </p>
        </section>

        <section className="gdpr-page__section">
          <h2 className="gdpr-page__heading">Doba uchovávania</h2>
          <ul className="gdpr-page__list">
            <li>
              Technické logy a IP adresy návštevníkov uchovávame len po dobu nevyhnutnú na
              zaistenie bezpečnosti (zvyčajne maximálne 6 mesiacov).
            </li>
            <li>
              Údaje manažérov prevádzok uchovávame počas trvania zmluvnej spolupráce s prevádzkou
              a po jej skončení len na dobu vyžadovanú daňovými a účtovnými predpismi.
            </li>
            <li>
              Údaje zákazníckeho účtu a história objednávok sa uchovávajú, kým účet trvá.
              <strong> Zrušením účtu sa konto deaktivuje</strong> — prestane sa dať prihlásiť
              a v prevádzke sa ďalej nezobrazuje. Samotné údaje (meno, kontakt, adresy
              a objednávky) zostávajú uložené, pretože sú súčasťou účtovných dokladov,
              ktoré musí prevádzka podľa zákona uchovávať <strong>10 rokov</strong>, a pretože
              sa z nich vychádza pri prípadnom nevyrovnanom nedoplatku. Po uplynutí tejto
              lehoty sa odstránia.
            </li>
            <li>
              Ak chcete údaje odstrániť skôr, požiadajte prevádzku. Vyhovieť vám môže
              v rozsahu, ktorý nie je potrebný na splnenie zákonnej povinnosti — teda
              spravidla pri údajoch bez väzby na uhradené objednávky.
            </li>
          </ul>
        </section>

        <section className="gdpr-page__section">
          <h2 className="gdpr-page__heading">Vaše práva</h2>
          <p>Podľa nariadenia GDPR máte právo požiadať nás o:</p>
          <ul className="gdpr-page__list">
            <li>prístup k vašim osobným údajom,</li>
            <li>opravu nesprávnych údajov,</li>
            <li>vymazanie údajov (ak už nie sú potrebné na účel, na ktorý sa získali),</li>
            <li>obmedzenie spracúvania,</li>
            <li>
              prenosnosť údajov, ktoré ste nám poskytli a spracúvame ich na základe
              zmluvy — na požiadanie vám ich vydáme v bežne použiteľnom formáte,
            </li>
            <li>namietať proti spracúvaniu založenému na oprávnenom záujme.</li>
          </ul>
          <p>
            <strong>Automatizované rozhodovanie ani profilovanie nevykonávame</strong> — o vašej
            objednávke rozhoduje človek v prevádzke.
          </p>
          <p>
            <strong>Je poskytnutie údajov povinné?</strong> Meno, telefón a adresa sú zmluvnou
            požiadavkou: bez nich vám objednávku nevieme doručiť ani vybaviť, takže ju nemôžeme
            prijať. E-mail je potrebný na založenie účtu a na potvrdenie objednávky. Prezerať
            si denné menu môžete bez poskytnutia akýchkoľvek údajov.
          </p>
          <p>
            Svoje práva si uplatníte u prevádzky, u ktorej si objednávate (kontakt nájdete v sekcii
            Kontakt a v obchodných podmienkach), alebo napíšte na admin@rozvozy.sk a žiadosť jej
            posunieme. Ak sa domnievate, že vaše údaje spracúvame v rozpore so zákonom, máte právo
            podať sťažnosť na Úrad na ochranu osobných údajov SR
            (Galvaniho 7/B, 821 04 Bratislava, www.dataprotection.gov.sk).
          </p>
        </section>
      </div>
    </main>
  );
}

export default GDPRPage;
